/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
} from 'prop-types';
import PageHeading from './PageHeading';
import PageContent from './PageContent';
import Data from './ViewData';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = (theme)  => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
        width: 980,
        background: theme.palette.backgroundColor,
    },
    headingBlock: {
        display: 'block',
        alignItems: 'center',
        background: theme.palette.backGroundColor,
        padding: '65px 0px 0px',

    },
    listBlock: {
        padding: '10px',
        width: '180px',
    },
    headingTitle: {
        fontSize: '40px',
        fontWeight: '100',
        textAlign: 'center',
        margin: '10px 0px',
        fontFamily: 'arial regular',
        color: theme.palette.OBHeadingColor,
    },

    main: {
        marginLeft: '220px',
        marginTop: '50px',

    },
    list: {
        padding: '5px 5px 5px 0px',
        width: '200px',
    },
    line: {
        border: `1px ${theme.palette.colorIconHeader} solid`,
        width: '55px',
        position: 'absolute',
        right: '45%',
    },
    listItem: {
        fontSize: '12px',
        lineHeight: '15px',
        color: theme.palette.colorIconHeader,
        listStyle: 'none',
        padding: '5px 0',
        fontFamily: '\'Roboto slab\', serif',
        letterSpacing: '0.03em',
        borderBottom: theme.palette.borderBottom,

    },
    imagelist: {
        display: 'flex',
        width: 980,
        position: 'relative',
    },
    logo: {
        position: 'absolute',
        top: '40px',
        left: '17%',
    },
    rightlogo: {
        position: 'absolute',
        top: '40px',
        right: '12%',
    },
    left: {
        display: 'block',
        width: '38%',
        height: '50px',
        textAlign: 'center',
        float: 'left',
        position: 'absolute',
        top: '30%',
        left: '5%',
        fontSize: '16px',
        fontFamily: 'Archer Book',
        fontWeight: '100',
        lineHeight: '20px',
        color: theme.palette.colorIconHeader,
    },
    right: {
        display: 'block',
        width: '42%',
        textAlign: 'center',
        float: 'left',
        position: 'absolute',
        top: '30%',
        right: '5%',
        fontSize: '16px',
        fontFamily: 'Archer Book',
        fontWeight: '100',
        lineHeight: '20px',
        color: theme.palette.colorIconHeader,

    },
    leftbtn: {
        color: `${theme.palette.white} !important`,
        textDecoration: 'none',
        backgroundColor: theme.palette.colorIconHeader,
        width: '230px',
        height: '45px',
        fontSize: '16px',
        fontFamily: 'archer bold',
        position: 'relative',
        top: '30px',
        padding: '14px',
        float: 'left',
    },
    button: {
        backgroundColor: theme.palette.colorIconHeader,
        height: '40px',
        width: '170px',
        fontSize: '16px',
        marginTop: '40px',
        color: theme.palette.white,
        borderWidth: '1px',
        marginRight: '45px',
        borderRadius: '0px',

    },
    buttonRight: {
        backgroundColor: theme.palette.colorIconHeader,
        height: '40px',
        width: '170px',
        fontSize: '16px',
        marginTop: '40px',
        color: theme.palette.white,
        borderWidth: '1px',
        marginRight: '45px',
        borderRadius: '0px',

    },
    anchorTag: {
        textDecorationLine: 'none',
        color: theme.palette.colorIconHeader,
    },
    BrandsButton: {
        textDecorationLine: 'none',
        color: theme.palette.white,
        fontFamily: 'Archer bold',
    },
});
const OurFamilyOfBrands = ({
    classes,
}) => {
    const {
        header_data: {
            title, listItem,
        },
        Page_Content: {
            buttonText,   OurBrandsHarryanddavid,  OurBrandsAboutusWolferman,  OurBrandsAboutusFruitbouquetsv2,  OurBrandsAboutusTpf,  OurBrandsAboutusCheryls,  OurBrandsAboutusBasket,
        },
        seo,
    } = Data;
    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <PageHeading
                headingTitle={title}
                listItem={listItem}
                classes={classes}
            />
            <PageContent
                classes={classes}
                buttonText={buttonText}
                OurBrandsHarryanddavid={OurBrandsHarryanddavid}
                OurBrandsAboutusWolferman={OurBrandsAboutusWolferman}
                OurBrandsAboutusFruitbouquetsv2={OurBrandsAboutusFruitbouquetsv2}
                OurBrandsAboutusTpf={OurBrandsAboutusTpf}
                OurBrandsAboutusCheryls={OurBrandsAboutusCheryls}
                OurBrandsAboutusBasket={OurBrandsAboutusBasket}
            />
        </>
    );
};

OurFamilyOfBrands.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(OurFamilyOfBrands);
